<template>
  <div>
    <OverviewHeader
      :headers="headersData"
      :icon="icon"
      :subtitle="subtitle"
      :tableId="tableId"
      :sortData="sortData"
      :sortBy="sortBy"
      :sortDesc="sortDesc"
      @openFilter="openFilter"
      @changeShowAll="changeShowAll"
      @changeShowTable="changeShowTable"
      @resettFilter="resettFilter"
      @clickSort="sortSelected"
    >
      <template v-slot:headlineBtns>
        <slot name="headlineBtns"></slot>
      </template>

      <template v-slot:btnMobile>
        <slot name="btnMobile"></slot>
      </template>
    </OverviewHeader>
    <div>
      <CardTable
        :headers="headersData"
        :data="data"
        :loading="loading"
        :titleKey="titleKey"
        :deadlineKey="deadlineKey"
        :underRightKey="underRightKey"
        :underLeft="underLeft"
        :totalItemCount="totalItemCount"
        :totalPages="totalPages"
        :tableId="tableId"
        :sortBy="sortBy"
        :sortDesc="sortDesc"
        @changeFilter="getData"
        @fetchData="bottomOfPage"
        @setColor="setColor"
        @click="clickCardTable"
        @updateSortBy="updateSortBy"
        @newPage="newPage"
        @updateItemsPerPage="updateItemsPerPage"
      >
        <template v-slot:title="{ item }">
          <slot name="title" :item="item"></slot>
        </template>
        <template v-slot:chips="{ item }">
          <slot name="chips" :item="item"></slot>
        </template>
        <!-- <template v-slot:deadline="{ item }">
          <slot name="deadline" :item="item"></slot>
        </template> -->
        <template v-slot:underRight="{ item }">
          <slot name="underRight" :item="item"></slot>
        </template>
        <template v-slot:underLeft="{ item }">
          <slot name="underLeft" :item="item"></slot>
        </template>

        <template v-slot:filter="{ head, item }">
          <slot
            :name="'filter.' + head.value"
            :item="item"
            :head="head"
            :isTable="true"
          >
          </slot>
        </template>

        <template v-slot:item="{ item, head }">
          <slot :name="'item.' + head.value" :item="item" :head="head"> </slot>
        </template>
      </CardTable>
    </div>

    <v-fab-transition>
      <v-btn
        v-show="$vuetify.breakpoint.mobile && !showTable"
        class="btnPsiCenter"
        color="primary"
        fixed
        @click="openSortDialog = true"
      >
        <v-icon left>mdi-swap-vertical</v-icon>
        Sorter
      </v-btn>
    </v-fab-transition>

    <BottomSortDialog
      v-model="openSortDialog"
      :data="sortData"
      @click="sortSelected"
    />

    <FilterDialog
      v-model="openFilterDialog"
      :headers.sync="headersData"
      :items="data"
      :title="$route.meta.headerName"
      dialogIcon="mdi-filter-variant"
      @changeShowAll="changeShowAll"
    >
      <template v-slot:filter="{ head, item }">
        <slot
          :name="'filter.' + head.value"
          :item="item"
          :head="head"
          :isTable="false"
        >
        </slot>
      </template>
    </FilterDialog>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import { HeaderObject, sortObject } from "@/types/tableInterface";

import OverviewHeader from "@/components/shared/overview/OverviewHeader.vue";
import CardTable from "@/components/shared/CardTable.vue";
import FilterDialog from "@/components/shared/dialog/FilterDialog.vue";
import BottomSortDialog from "@/components/shared/overview/BottomSortDialog.vue";

export default Vue.extend({
  props: {
    data: {
      type: Array,
      required: true,
    },
    headers: {
      type: Array,
    },
    icon: {
      type: String,
    },
    subtitle: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: true,
    },
    totalPages: {
      type: Number,
      default: 0,
    },
    totalItemCount: {
      type: Number,
      default: -1,
    },
    titleKey: {
      type: String,
      default: "name",
    },
    underRightKey: {
      type: String,
      default: "assignedTo",
    },
    underLeft: {
      type: String,
      default: "project",
    },
    deadlineKey: {
      type: String,
      default: "deadline",
    },
    defaultSortBy: {
      default: () => [] as Array<string>,
    },
    defaultSortDesc: {
      default: () => [] as Array<string>,
    },
  },

  data: () => ({
    openFilterDialog: false,
    openSortDialog: false,
    showCardsCount: 100,
    page: 1,
    _timerId: 0,
  }),

  async mounted() {
    if (!this.filter) {
      await this.getHeaderData(this.tableId);
    }

    if (this.tableId !== this.showAll.id || this.filter) {
      this.setShowAll({
        id: this.tableId,
        value: this.filter ? this.filter.showAll : false,
      });
    }

    this.showCardsCount = this.showTable ? 10 : 100;

    if (this.tableId !== this.tableHeaders.tableId || this.filter) {
      this.setHeader();
    }
    // else {
    //   this.getData();
    // }
  },
  watch: {
    headersData: {
      handler: function (newVal, oldVal) {
        var vm = this;
        if (newVal?.length > 0 && oldVal?.length > 0) {
          // // cancel pending call
          // clearTimeout(this._timerId);
          // // delay new call 500ms
          // this._timerId = setTimeout(() => {
          vm.saveHeaders();
          vm.getData();
          // }, 200);
        } else if (newVal?.length > 0 && oldVal?.length === 0) {
          // clearTimeout(this._timerId);
          // // delay new call 500ms
          // this._timerId = setTimeout(() => {
          vm.getData();
          // }, 200);
        }
      },
      deep: true,
    },
    headers: {
      handler: function (newVal, oldVal) {
        //Only first time
        if (newVal?.length > 0 && oldVal?.length === 0) {
          //Save header before getData
          var vm = this;
          // cancel pending call
          // clearTimeout(this._timerId);
          // delay new call 500ms
          // this._timerId = setTimeout(() => {
          vm.saveHeaders();
          // vm.getData();
          // }, 200);
        }
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions({
      setTableHeaders: "tables/tableHeaders",
      setShowTable: "tables/setShowTable",
      setShowAll: "tables/setShowAll",
      resetToDefault: "tables/resetToDefault",
      getHeaderData: "tables/getHeaderData",
    }),
    updateItemsPerPage(itemsPerPage) {
      this.showCardsCount =
        itemsPerPage !== -1 ? itemsPerPage : this.totalItemCount;
      this.getData();
    },
    newPage(pageNummer) {
      //Table click next page
      this.page = pageNummer;
      this.getData();
    },
    bottomOfPage(bottomOfPage = false) {
      if (bottomOfPage && this.page < this.totalPages) {
        this.page = this.page + 1;
        this.getData(bottomOfPage);
      }
    },
    async getData(bottomOfPage = false) {
      var headers = JSON.parse(JSON.stringify(this.headersData));
      headers.forEach((x) => {
        if (
          (x.filterValues || x.filterValues === 0) &&
          !Array.isArray(x.filterValues)
        ) {
          x.filterValues = [x.filterValues];
        } else if (
          Array.isArray(x.filterValues) &&
          x.filterValues.length === 0
        ) {
          if (x.type === "string") {
            x.filterValues = "";
          }
        }
      });
      //If filter without table. Not bttom and not table
      if (!this.showTable && !bottomOfPage) {
        this.page = 1;
      }

      var data = {
        headers: headers,
        search: "",
        page: this.page,
        itemsPerPage: this.showCardsCount,
        sortBy: this.sortBy || this.defaultSortBy,
        sortDesc: this.sortDesc || this.defaultSortDesc,
      };
      this.fetchData(data, bottomOfPage);
    },
    async fetchData(data, bottomOfPage = false) {
      if (this.data.length === 0 || bottomOfPage) {
        data.hideLoader = true;
      }
      this.$emit("fetchData", { data, bottomOfPage });
      this.$emit("setSubtitle");
    },
    changeShowTable(value: boolean) {
      this.showCardsCount = value ? 10 : 100;
      this.setShowTable(value);
      this.getData();
    },
    clickCardTable(item: any) {
      this.$emit("click", item);
    },
    async changeShowAll(value: boolean) {
      this.setShowAll({ id: this.tableId, value: value });
      this.$emit("changeShowAll", value);

      this.setHeader();
    },
    async saveHeaders() {
      var data = this.tableHeaders;
      this.$set(
        data,
        "headers",
        this.headersData.length > 0 ? this.headersData : this.headers
      );

      this.$set(data, "sortBy", this.sortBy || this.defaultSortBy);
      this.$set(data, "sortDesc", this.sortDesc || this.defaultSortDesc);

      data.tableId = this.tableId;
      await this.setTableHeaders(data);
    },
    resettFilter() {
      this.resetToDefault();
    },
    setHeader() {
      this.$emit("setHeader");
    },
    setColor(item: any) {
      this.$emit("setColor", item);
    },
    openFilter() {
      this.openFilterDialog = true;
    },
    sortSelected(item: any) {
      var sortDesc = true;
      if (this.tableHeaders?.sortBy?.[0] === item.sortBy) {
        sortDesc = this.tableHeaders?.sortDesc?.[0] ? false : sortDesc;
      }

      this.$set(this.tableHeaders, "sortBy", [item.sortBy]);
      this.$set(this.tableHeaders, "sortDesc", [sortDesc]);

      this.saveHeaders();

      this.getData();
    },
    updateSortBy(item: any) {
      if (
        this.tableHeaders?.sortBy?.[0] !== item.sortBy ||
        this.tableHeaders?.sortDesc?.[0] !== item.sortDesc
      ) {
        var sortDesc = true;
        if (this.tableHeaders?.sortBy?.[0] === item.sortBy) {
          sortDesc = item.sortDesc;
        }

        this.$set(this.tableHeaders, "sortBy", [item.sortBy]);
        this.$set(this.tableHeaders, "sortDesc", [sortDesc]);
        this.saveHeaders();
        this.getData();
      }
    },
  },

  computed: {
    ...mapGetters({
      isTrysilhus: "shared/isTrysilhus",
      showTable: "tables/showTable",
      showAll: "tables/showAll",
      tableHeaders: "tables/tableHeaders",
      defaultTableHeaders: "tables/defaultTableHeaders",
      filter: "tables/filter",
    }),
    headersData: {
      get(): Array<HeaderObject> {
        if (
          this.tableId &&
          this.tableHeaders.headers &&
          this.tableHeaders.tableId === this.tableId
        ) {
          return this.tableHeaders.headers as Array<HeaderObject>;
        }

        return [] as Array<HeaderObject>;
      },
    },
    tableId(): string {
      if (this.$route.name) {
        return `BT${this.$route.name}`;
      }

      return "BTOverview";
    },
    sortData(): Array<sortObject> {
      //Array user can sort data from
      var data = [] as Array<sortObject>;

      this.headersData.forEach((x) => {
        if (!x.removeFilter && x.sortable !== false) {
          data.push({
            name: x.text,
            sortBy: x.value,
            sortDesc:
              this.tableHeaders?.sortBy?.[0] === x.value
                ? this.tableHeaders?.sortDesc?.[0]
                : null,
            selected: this.tableHeaders?.sortBy?.[0] === x.value,
          });
        }
      });

      return data;
    },
    sortBy(): Array<string> {
      return this.tableHeaders?.tableId === this.tableId
        ? this.tableHeaders?.sortBy
        : null || this.defaultSortBy;
    },
    sortDesc(): Array<boolean> {
      return this.tableHeaders?.tableId === this.tableId
        ? this.tableHeaders?.sortDesc
        : null || this.defaultSortDesc;
    },
  },
  components: {
    OverviewHeader,
    CardTable,
    FilterDialog,
    BottomSortDialog,
  },
});
</script>

<style lang="scss" scoped>
.btnPsiCenter {
  z-index: 2;
  left: 50%;
  bottom: calc(50px + env(safe-area-inset-bottom));
  transform: translate(-50%, -50%);
}
</style>
